import React from 'react'
import HeaderInner from '../header/HeaderInner';
import Project from './breadcrumb/Project';
import Footer from '../elements/Footer';

function Appoinment() {
  return (
    <div className='service-details'>
      <div>
        <HeaderInner />
        <main>
          <Project />

          {/* Portfolio / Gallery */}
          <div className="portfolio-area portfolio-style-three tmp-section-gap bg_image bg-image-none">
            <div className="container">
              <div className="row g-4">

                {/* Image 1 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga.jpg" alt="Dummy 1" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 2 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga2.jpg" alt="Dummy 2" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 3 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga3.jpg" alt="Dummy 3" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 4 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga4.jpg" alt="Dummy 4" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 5 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga5.jpg" alt="Dummy 5" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 6 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga6.jpg" alt="Dummy 6" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 7 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga7.jpg" alt="Dummy 7" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 8 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga8.jpg" alt="Dummy 8" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 9 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga9.jpg" alt="Dummy 9" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 10 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga10.jpg" alt="Dummy 10" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 11 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga11.jpg" alt="Dummy 11" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 12 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga12.jpg" alt="Dummy 12" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 13 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga13.jpg" alt="Dummy 13" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 14 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga14.jpg" alt="Dummy 14" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 15 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga15.jpg" alt="Dummy 15" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 16 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga16.jpg" alt="Dummy 16" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 17 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga17.jpg" alt="Dummy 17" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 18 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga18.jpg" alt="Dummy 18" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 19 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga19.jpg" alt="Dummy 19" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

                {/* Image 20 */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div className="portfolio-inner">
                    <img src="assets/images/cta/ga20.jpg" alt="Dummy 20" className="w-100 h-100" style={{ borderRadius: "10px", objectFit: "cover", aspectRatio: "4 / 3" }} />
                  </div>
                </div>

              </div>
            </div>
          </div>

          <Footer />
        </main>
      </div>
    </div>
  )
}

export default Appoinment
